import { isNumber, isString } from '@/mixins/typeCheck'

export const ensureString = (value: any) => {
  return isString(value) ? value : value.toString()
}

export const ensureInteger = (value: any) => {
  return isNumber(value) ? value : Number(value)
}

export const ensureFloat = (value: string, precision = 2) => {
  return Number(Math.round(ensureInteger(value)).toFixed(precision))
}

export const ensureNoDoubleSlash = (value: any) => {
  // eslint-disable-next-line
  return value.replace(/(https?:\/\/)|(\/){2,}/g, '$1$2')
}
